const SurveyQuestionType = {
  MULTI_SELECT: "MULTI_SELECT",
  OPEN: "OPEN"
};

const OptionLetter = {
  0: "A",
  1: "B",
  2: "C",
  3: "D",
  4: "E",
  5: "F",
  6: "G",
  7: "H",
  8: "I",
  9: "J",
  10: "K"
};

const SurveyTagType = {
  MANAGER: "MANAGER",
  MANAGER_ASSISTANT: "MANAGER_ASSISTANT",
  CLUB_TEACHER: "CLUB_TEACHER",
  TEACHER: "TEACHER",
  GUIDANCE_TEACHER: "GUIDANCE_TEACHER",
  MENTOR_TEACHER: "MENTOR_TEACHER",
  COURSE_CURRICULUM: "COURSE_CURRICULUM",
  EDITION: "EDITION",
  ACTIVITIES: "ACTIVITIES",
  SCHOOL_LIVING_SPACES: "SCHOOL_LIVING_SPACES",
  SUPPORT_SERVICES: "SUPPORT_SERVICES",
  CORPORATE_COMMUNICATIONS: "CORPORATE_COMMUNICATIONS",
  HEALTH: "HEALTH",
  SCHOOL_ENVIRONMENT: "SCHOOL_ENVIRONMENT",
  ACADEMIC: "ACADEMIC",
  FAMILY: "FAMILY",
  SOCIETY_ENVIRONMENT_RELATIONSHIP: "SOCIETY_ENVIRONMENT_RELATIONSHIP",
  SELF_EVALUTION: "SELF_EVALUTION",
  JOB_INVENTORY: "JOB_INVENTORY",
  GENERAL: "GENERAL",
  REHBER_ZIRVE: "REHBER_ZIRVE"
};

const SurveyTagLabel = {
  MANAGER: "Müdür",
  MANAGER_ASSISTANT: "Müdür Yardımcısı",
  CLUB_TEACHER: "Kulüp Öğretmeni",
  TEACHER: "Öğretmen",
  GUIDANCE_TEACHER: "Rehber Öğretmen",
  MENTOR_TEACHER: "Mentör Öğretmen",
  COURSE_CURRICULUM: "Dersler/Müfredat",
  EDITION: "Yayın",
  ACTIVITIES: "Sosyal,Kültürel,Sportif vb. Faaliyetler",
  SCHOOL_LIVING_SPACES: "Okul Yaşam Alanları",
  SUPPORT_SERVICES: "Destek Hizmetler",
  CORPORATE_COMMUNICATIONS: "Kurumsal İletişim",
  HEALTH: "Sağlık",
  SCHOOL_ENVIRONMENT: "Okul Ortamı",
  ACADEMIC: "Akademik",
  FAMILY: "Aile",
  SOCIETY_ENVIRONMENT_RELATIONSHIP: "Toplum-Çevre İlişkisi",
  SELF_EVALUTION: "Kendini Değerlendirme",
  JOB_INVENTORY: "Meslekler Envanteri",
  GENERAL: "Genel",
  REHBER_ZIRVE: "2024 REHBERLİK ZİRVESİ ANKETİ"
};

const ObligatoryTags = {
  COURSE_CURRICULUM: true,
  EDITION: true,
  ACTIVITIES: true,
  SCHOOL_LIVING_SPACES: true,
  SUPPORT_SERVICES: true,
  CORPORATE_COMMUNICATIONS: true,
  HEALTH: true,
  SCHOOL_ENVIRONMENT: true,
  ACADEMIC: true,
  FAMILY: true,
  SOCIETY_ENVIRONMENT_RELATIONSHIP: true,
  SELF_EVALUTION: true,
  JOB_INVENTORY: true,
  GENERAL: true
};

const isObligatoryTag = (tag) => Object(ObligatoryTags).hasOwnProperty(tag);

export { SurveyQuestionType, OptionLetter, SurveyTagType, SurveyTagLabel, isObligatoryTag };
